var $dc6e3b2813600d69$exports = {};
$dc6e3b2813600d69$exports = {
  "close": "Bez\xE1r\xE1s",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \xE9rtes\xEDt\xE9s");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \xE9rtes\xEDt\xE9s");
      }
    }), ".");
  }
};
export { $dc6e3b2813600d69$exports as default };